import { InquiryContext } from '@/contexts/InquiryContext.js';
import { useContext } from 'react';

export const useInquiry = () => {
  const value = useContext(InquiryContext);
  return value;
};
